// extracted by mini-css-extract-plugin
module.exports = {"root":"TakeCameraPhoto_root__2xysT","camera":"TakeCameraPhoto_camera__JTkTf"};